
export const environment = {
  production: false,
  domainName: "https://api.eltai.in/",
  fDomainName: "https://indiareads.eltai.in/",

  keyId: "rzp_test_0GXTYoCT8cWQAv"
};